import { render, staticRenderFns } from "./PeopleSelector.vue?vue&type=template&id=e073d842"
import script from "./PeopleSelector.vue?vue&type=script&lang=js"
export * from "./PeopleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports